import PriceSidebar from "./PriceSidebar";

export default PriceSidebar;
